// this was copied from here: https://stackoverflow.com/a/58989019/1958910
import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
  selector: '[appMin]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CustomMinDirective, multi: true }]
})
export class CustomMinDirective implements Validator {

  @Input() appMin: number;

  validate(c: FormControl): { [key: string]: any } {
    return (c.value < this.appMin) ? { appMin: true } : null;
  }
}
